import { Component } from '@opten/compiler/metadata/component';
import scrollToElement from '@opten/scroll/scroll-to-element';
import * as mixitup from 'mixitup';

@Component({ className: 'js-filter' })
export class Filter {

	private container: HTMLElement;

	private options = {
		selectors: {
			target: '.js-filter-target',
		},
		animation: {
			duration: 500,
		},
	};

	constructor(private element: HTMLElement) {
		this.container = element.querySelector('.js-filter-container');

		this.init();
	}

	private init() {
		const mixer = mixitup(this.container, this.options);

		if (window.location.hash) {
			const filter = window.location.hash.substr(1, window.location.hash.length);
			mixer.filter(`.${filter}`);
			scrollToElement(this.element);
		}
	}
}
